var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Multiselect",
    {
      attrs: {
        "track-by": "id",
        label: "name",
        placeholder: _vm.i18n.placeholder,
        options: _vm.options,
        loading: _vm.loading
      },
      model: {
        value: _vm.value,
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    },
    [
      _c("template", { slot: "noResult" }, [
        _c("span", { staticClass: "multiselect__noresult" }, [
          _vm._v("\n      " + _vm._s(_vm.i18n.noResults) + "\n    ")
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }